// TEXT WITH ICONS BAR
document.addEventListener('DOMContentLoaded', () => {
  // Set a default value of 0px for the CSS variable
  document.documentElement.style.setProperty('--text-with-icons-height', '0px');

  const textWithIconsBar = document.querySelector('.text-with-icons-bar');
  
  function setTextWithIconsHeight() {
    if (textWithIconsBar && textWithIconsBar.offsetHeight > 0) {
      const textWithIconsHeight = textWithIconsBar.offsetHeight;
      document.documentElement.style.setProperty('--text-with-icons-height', `${textWithIconsHeight}px`);
    }
  }

  // Calculate height initially
  setTextWithIconsHeight();
}); 


// COUNTDOWN BAR
document.addEventListener('DOMContentLoaded', () => {
  // Set a default value of 0px for the CSS variable
  document.documentElement.style.setProperty('--countdown-height', '0px');

  const countdownBar = document.querySelector('.countdown-bar');
  
  function setCountdownHeight() {
    if (countdownBar && countdownBar.offsetHeight > 0) {
      const countdownHeight = countdownBar.offsetHeight;
      document.documentElement.style.setProperty('--countdown-height', `${countdownHeight}px`);
    }
  }

  // Calculate height initially and after a 1-second delay
  setCountdownHeight();

  setTimeout(() => {
    setCountdownHeight();
  }, 1000);
});  